var ee = require('namespace-emitter');
module.exports = /*#__PURE__*/
function () {
  function UppySocket(opts) {
    var _this = this;
    this.queued = [];
    this.isOpen = false;
    this.socket = new WebSocket(opts.target);
    this.emitter = ee();
    this.socket.onopen = function (e) {
      _this.isOpen = true;
      while (_this.queued.length > 0 && _this.isOpen) {
        var first = _this.queued[0];
        _this.send(first.action, first.payload);
        _this.queued = _this.queued.slice(1);
      }
    };
    this.socket.onclose = function (e) {
      _this.isOpen = false;
    };
    this._handleMessage = this._handleMessage.bind(this);
    this.socket.onmessage = this._handleMessage;
    this.close = this.close.bind(this);
    this.emit = this.emit.bind(this);
    this.on = this.on.bind(this);
    this.once = this.once.bind(this);
    this.send = this.send.bind(this);
  }
  var _proto = UppySocket.prototype;
  _proto.close = function close() {
    return this.socket.close();
  };
  _proto.send = function send(action, payload) {
    // attach uuid
    if (!this.isOpen) {
      this.queued.push({
        action: action,
        payload: payload
      });
      return;
    }
    this.socket.send(JSON.stringify({
      action: action,
      payload: payload
    }));
  };
  _proto.on = function on(action, handler) {
    this.emitter.on(action, handler);
  };
  _proto.emit = function emit(action, payload) {
    this.emitter.emit(action, payload);
  };
  _proto.once = function once(action, handler) {
    this.emitter.once(action, handler);
  };
  _proto._handleMessage = function _handleMessage(e) {
    try {
      var message = JSON.parse(e.data);
      this.emit(message.action, message.payload);
    } catch (err) {
      console.log(err);
    }
  };
  return UppySocket;
}();